<template functional>
  <div class="flex items-center gap-0.5">
    <div class="w-5" :class="{ 'grayscale opacity-50': !props.item.completed }">
      <svg
        width="20"
        height="20"
        viewBox="0 0 1.44 1.44"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.646 1.249a0.529 0.529 0 1 1 0.315 -0.953 0.045 0.045 0 0 1 -0.053 0.072 0.439 0.439 0 1 0 0.178 0.352 0.75 0.75 0 0 0 -0.005 -0.069 0.045 0.045 0 1 1 0.09 -0.014 0.75 0.75 0 0 1 0.005 0.083 0.529 0.529 0 0 1 -0.529 0.529"
          style="fill: #0074ff"
        />
        <path
          d="M0.704 0.889a0.045 0.045 0 0 1 -0.032 -0.013L0.458 0.661A0.045 0.045 0 0 1 0.522 0.598l0.182 0.181 0.542 -0.541a0.045 0.045 0 0 1 0.064 0.064l-0.574 0.574a0.045 0.045 0 0 1 -0.032 0.013"
          style="fill: #ffb300"
        />
      </svg>
    </div>
    <a
      class="text-sm cursor-pointer"
      :data-action="'viewOrder'"
      :data-order-id="props.item.id"
    >
      {{ props.item.id }}
    </a>
    <div
      class="bg-tz-base w-4 p-0.5 rounded-full"
      v-if="props.item.order_source"
    >
      <svg
        fill="none"
        width="12"
        height="12"
        viewBox="0 0 32 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3933 0H16.8989H0L2.06742 4.72817H5.93259L10.427 18.9124L17.6179 19L13.1236 4.81562H20.9438L17.7978 14.447L19.3259 19H29.8427L32 14.447C32 14.447 25.7977 14.447 24.4494 14.447L29.3933 0Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-id",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
